import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "@phosphor-icons/react";
import Logo from "../components/common/Logo";

/**
 * ForgotPasswordPage - Admin-assisted reset hint.
 * There is no self-service email reset flow — an Organization Admin or
 * Super Admin must generate a temporary password for the user from the
 * Admin Portal (Users table -> Reset Password).
 */
export default function ForgotPasswordPage() {
  return (
    <div
      className="min-h-screen password-bg flex items-center justify-center p-4"
      data-testid="forgot-password-screen"
    >
      <div className="absolute inset-0 bg-white/80 backdrop-blur-sm" />

      <div className="relative z-10 w-full max-w-md">
        <div className="bg-white border border-slate-200 p-8 shadow-lg">
          <div className="text-center mb-6">
            <div className="inline-flex items-center justify-center mb-4">
              <Logo size={56} />
            </div>
            <h1 className="font-cabinet text-2xl font-black tracking-tight text-slate-900 mb-2">
              Forgot Password?
            </h1>
          </div>

          <div
            className="bg-blue-50 border border-blue-200 rounded-sm p-4 flex items-start gap-3"
            data-testid="forgot-password-hint"
          >
            <ShieldCheck size={22} className="text-blue-600 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-blue-900 leading-relaxed">
              To reset your password, please contact your{" "}
              <span className="font-semibold">Organization Administrator</span> or{" "}
              <span className="font-semibold">Super Admin</span>, who can securely reset
              your credentials from the Admin Dashboard.
            </p>
          </div>

          <Link
            to="/"
            data-testid="forgot-password-back-link"
            className="mt-8 flex items-center justify-center gap-2 w-full text-sm text-slate-600 hover:text-slate-900 font-medium transition-colors"
          >
            <ArrowLeft size={16} />
            Back to Sign In
          </Link>
        </div>
      </div>
    </div>
  );
}
